// @flow
import React from 'react'
import type { ServicesType } from 'catena/er2_map_services/js/reducers/services'
import type { MapsourcesType } from 'catena/er2_map_userlayers/js/reducers/mapsources'
import Search from './search'

type PropsType = {
    mapsources: MapsourcesType,
    services: ServicesType,
    theme: {},
    token: {
        value: string,
    }
}

type StateType = {
    helpSearchActive: boolean,
    lampsLayer?: string,
    service?: string,
    suggestions: ServicesType[],
}

// eslint-disable-next-line react/prefer-stateless-function
class Services extends React.Component<PropsType, StateType> {
    constructor(props) {
        super(props)
        this.state = {
            helpSearchActive: false,
            suggestions: this.props.services.items,
        }
    }

    getSelectedService() {
        const service = this.props.services.items.find(s => s.name === this.state.service)
        return service
    }

    getSuggestions = (inputValue) => {
        const value = inputValue && inputValue.value ? inputValue.value.trim().toLowerCase() : ''
        const tokens = value.split(' ')
        const inputLength = value.length
        let count = 0

        const suggestions = inputLength === 0
            ? this.props.services.items
            : this.props.services.items.sort((a, b) => a.description.localeCompare(b.description)).filter((suggestion) => {
                const lbl = suggestion.description.toLowerCase()
                let idx = 0
                const matches = tokens.every((tkn) => {
                    const foundIdx = lbl.indexOf(tkn, idx)
                    if (foundIdx < idx) {
                        // console.log(`Couldn't find ${tkn} at ${lbl}. foundIdx = ${foundIdx}, idx = ${idx}`)
                        return false
                    }
                    // console.log(`Found ${tkn} at ${lbl} = ${foundIdx}`)
                    idx = foundIdx
                    return true
                })

                const keep = count < 100 && matches
                if (keep) {
                    count += 1
                }
                return keep
            })
        this.setState({ suggestions })
    }

    onChangeService = (service) => {
    }

    selectService = (service) => {
        this.setState({ service: service.name })
    }

    renderSearch() {
        const theme = this.props.theme
        return (
            <div className={theme.geoBarCtr}>
                <div className={theme.formGroup}>
                    <span className={theme.description}>Search for a Service</span>
                    <i
                        className={`${theme.helpIcon}
                        ${this.state.helpSearchActive ? theme.helpIconActive : ''}
                        fa fa-question-circle`}
                        onClick={() => this.setState({ helpSearchActive: !this.state.helpSearchActive })}
                        role="button"
                        tabIndex={0}
                    />
                </div>
                {this.state.helpSearchActive && (
                    <div className={theme.helpInlineCtr}>
                        <div className={theme.helpInline}>
                            <p>
                                Enter the name of a service tool to use.
                            </p>
                            <p>
                                All service tools in Catena can be found within the search box above.
                                They are indexed by a number of keywords, so that you don&#39;t have to remember the
                                exact name of the tool beforehand.
                            </p>
                            <p>
                                For instance, try typing &quot;landuse&quot;.  Tools that extract climate data will
                                be shown below.
                            </p>
                            <p>
                                Once the service you wish to use is visible in the search results, select the tool with your
                                mouse or use the keyboard to navigate to the result and type Enter.
                            </p>
                            <p>
                                The following services tools are currently available with Catena:
                            </p>
                            <ul>
                                {this.props.services.items.sort((a, b) => a.description.localeCompare(b.description)).map(tool => (
                                    <li key={tool.id}>{tool.description}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}
                <div className={this.props.theme.formGroup}>
                    <Search
                        onChange={this.onChangeService}
                        onSelect={this.selectService}
                        onSuggestionsFetchRequested={this.getSuggestions}
                        onSuggestionsClearRequested={this.getSuggestions}
                        suggestions={this.state.suggestions}
                        theme={this.props.theme}
                    />
                </div>
            </div>
        )
    }

    renderService() {
        return (<div className={this.props.theme.geoBarCtr}>
            {this.getSelectedService().render(this.props)}
        </div>)
    }

    render() {
        const theme = this.props.theme
        return (
            <div className={theme.mapToolbarTop}>
                <h3 className={theme.mapToolbarTitleBar}>Services</h3>
                <div className={theme.geoBarPanelScroll}>
                    {!this.state.service && this.renderSearch()}
                    {this.state.service && this.renderService()}
                </div>
            </div>
        )
    }
}

export default Services
